/* eslint-disable @typescript-eslint/no-explicit-any */
import { get } from 'lodash'
import { transparentize } from 'polished'
import React, { FC, ReactElement, useCallback, useState } from 'react'
import Select, { components, StylesConfig } from 'react-select'
import { GREEN, WHITE } from '../../utils/colors'
import { Field, Form } from '../input'
import { Container, Outside } from '../input/styles'
import { Container as ContainerSelectInput } from './style'

export type OptionsType = {
  label: string;
  value: string;
  image?: string;
};

export type SelectInputProps = {
  field?: Field;
  form?: Form;
  label?: string;
  value?: any;
  id?: string;
  name?: string;
  info?: string | ReactElement | ReactElement[];
  size?: 'md' | 'lg' | 'sm';
  options: OptionsType[];
  onChange?: (e: OptionsType) => void;
  onBlur?: (e: any) => any;
}

type IsMulti = false;

const styles: StylesConfig<OptionsType, IsMulti> = {
  option: (styles, { isSelected }) => {
    return {
      ...styles,
      color: isSelected ? `${WHITE} !important` : styles.color,
      backgroundColor: isSelected ? transparentize(0.2, GREEN) : styles.backgroundColor
    }
  }
}

const componentsNew = {
  Option (props: any) {
    return (
      <components.Option {...props}>
        {props.data?.image
          ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img
                src={props.data?.image}
                alt={`${props.data?.label} - logo`}
                style={{ backgroundColor: '#fff', width: 75, borderRadius: 4, marginRight: 10 }}
              />
              {props.data?.label}
            </div>
          )
          : <span>{props.data?.label}</span>}
      </components.Option>
    )
  }
}

const SelectInput: FC<SelectInputProps> = ({
  field,
  form,
  info,
  id,
  label,
  value: _value,
  options,
  name: _name,
  onChange: _onChange,
  onBlur
}): ReactElement => {
  const [isFocused, setIsFocused] = useState(false)
  const name = field?.name || _name || ''

  const errorMessage = name ? get(form?.errors, name) : null
  const touched = name ? get(form?.touched, name) : null
  const error = touched && errorMessage
  const value = field?.value || _value

  const onChange = useCallback((option) => {
    if (form) {
      form.setFieldValue(name, option.value)
    } else if (_onChange) {
      _onChange(option)
    }
  }, [form, _onChange])

  return (
    <Outside className='select'>
      <Container>
        <ContainerSelectInput>
          <Select
            onFocus={() => setIsFocused(true)}
            onBlur={(e) => {
              setIsFocused(false)
              const _onBlur = field?.onBlur || onBlur
              if (_onBlur) _onBlur(e)
            }}
            onChange={onChange}
            id={id}
            value={options.find(option => option.value === value)}
            name={name}
            options={options}
            placeholder=''
            components={componentsNew}
            className='select_input'
            styles={styles}
          />
        </ContainerSelectInput>
        {label && <label className={(isFocused || value) ? 'focus' : undefined}>{label}</label>}
      </Container>
      {error && <span className='error'>{error}</span>}
      {info && <span className='info'>{info}</span>}
    </Outside>
  )
}

export default SelectInput
